module.exports = __webpack_public_path__ + "static/media/tablet.429b2044.svg";